enum Currency {
  USD = 'currency/usd',
  GBP = 'currency/gbp',
  CAD = 'currency/cad'
}

enum Numeric {
  Percentage = 'numeric-class/percentage',
  PositiveInteger = 'numeric-class/positive-integer',
  PositiveDecimal = 'numeric-class/positive-decimal'
}

enum Finance {
  Expenses = 'finance/expenses',
  Revenues = 'finance/revenues',
  Assets = 'finance/assets',
  Liabilities = 'finance/liabilities',
  Equities = 'finance/equities'
}

enum Check {
  Amount = 'check-data/check-amount',
  Department = 'check-data/department',
  PaidTo = 'check-data/paid-to',
  Date = 'check-data/check-date',
  CheckNo = 'check-data/check-no',
  ExpenseType = 'check-data/expense-type',
  VoucherID = 'check-data/voucher-id',
  VendorCity = 'check-data/vendor-city',
  VendorState = 'check-data/vendor-state',
  VendorZip = 'check-data/vendor-zip',
  Fund = 'check-data/fund',
  Program = 'check-data/program',
  Ali = 'check-data/ali',
  DocumentID = 'check-data/--zz0x-document-id',
  Expense = 'check-data/--zz0x-expense'
}

enum Geometry {
  Point = 'geometry/point',
  Linestring = 'geometry/linestring',
  Polygon = 'geometry/polygon',
  MultiPoint = 'geometry/multi-point',
  MultiLinestring = 'geometry/multi-linestring',
  MultiPolygon = 'geometry/multi-polygon'
}

enum Metadata {
  Label = 'metadata/label',
  Description = 'metadata/description',
  AllConcat = 'metadata/all-concat'
}

enum Period {
  GregorianMonthNumeric = 'period/gregorian-month-numeric',
  GregorianYearNumeric = 'period/gregorian-year-numeric',
  FiscalMonth = 'period/fiscal-month',
  FiscalYear = 'period/fiscal-year',
  FiscalQuarter = 'period/fiscal-quarter'
}

enum Calendar {
  GregorianYear = 'urn:opengov:types/semantic/calendar/gregorian/year'
}

enum Dimension {
  Key = 'dimension/key',
  Column = 'dimension/column'
}

enum Hierarchy {
  Attribute = 'hierarchy/attribute'
}

enum Account {
  Ignored = 'account/ignored'
}

enum StructuredDataType {
  // tslint:disable-next-line:no-http-string
  MonetaryAmount = 'http://schema.org/MonetaryAmount',
  MonetaryAmountHttps = 'https://schema.org/MonetaryAmount'
}

const SystemGenerated = 'system-generated';

export const SemanticTypes = {
  Account,
  Calendar,
  Check,
  Currency,
  Dimension,
  Finance,
  Geometry,
  Hierarchy,
  Metadata,
  Numeric,
  Period,
  StructuredDataType,
  SystemGenerated
};
